"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const cachedAssetResolverBase_1 = __importDefault(require("@aurora/shared-apollo/resolvers/assets/cachedAssetResolverBase"));
const enums_1 = require("@aurora/shared-types/overrides/enums");
const ModuleHelper_1 = __importDefault(require("@aurora/shared-utils/helpers/ModuleHelper/ModuleHelper"));
let assetCaches;
/**
 * When server side, attempt to get the asset from the asset cache, when on the client side
 * attempt to get the asset from the Aurora-based "overrides" middleware which delegates to the
 * asset cache. If the asset is not found in the cache, then a call will be made to the LIA
 * GraphQL to fetch the asset or in the case of getting the default asset it will be loaded
 * directly from the file system.
 *
 * @param assetId the id of the asset to load
 * @param type the type of asset to get
 * @param node the node the asset is scoped to, if any
 * @param locale the locale of the asset is scoped to, if any
 * @param client the apollo client
 * @param tenant the tenant/.
 * @param lastModified the last modified time of the asset or "0" if not modified, "-1" to force fetch
 */
function getCachedAsset(assetId, type, node, locale, client, tenant, lastModified) {
    return __awaiter(this, void 0, void 0, function* () {
        if (typeof window === 'undefined') {
            const userClientProvider = () => Promise.resolve(client);
            if (!assetCaches) {
                assetCaches = (yield ModuleHelper_1.default.unwrapDynamicImport(Promise.resolve().then(() => __importStar(require('@aurora/shared-server/server/assets/assetCaches'))), 'getAssetCaches'))();
            }
            switch (type) {
                case enums_1.CachedAssetType.COMPONENT: {
                    return assetCaches.componentCache.findAsset(userClientProvider, tenant, assetId, node, locale, lastModified);
                }
                case enums_1.CachedAssetType.QUILT: {
                    return assetCaches.quiltCache.findAsset(userClientProvider, tenant, assetId, node, locale, lastModified);
                }
                case enums_1.CachedAssetType.THEME: {
                    return assetCaches.themeCache.findAsset(userClientProvider, tenant, assetId, node, locale, lastModified);
                }
                case enums_1.CachedAssetType.WRAPPER: {
                    return assetCaches.quiltWrapperCache.findAsset(userClientProvider, tenant, assetId, node, locale, lastModified);
                }
                case enums_1.CachedAssetType.PAGES: {
                    return assetCaches.pagesCache.findAsset(userClientProvider, tenant, assetId, node, locale, lastModified);
                }
                case enums_1.CachedAssetType.PAGE_SCRIPTS: {
                    return assetCaches.pageScriptsCache.findAsset(userClientProvider, tenant, assetId, node, locale, lastModified);
                }
            }
            throw new Error('Unsupported asset type:' + type);
        }
    });
}
exports.default = (0, cachedAssetResolverBase_1.default)(getCachedAsset);
//# sourceMappingURL=cachedAssetResolver.js.map